import React from 'react';
import Container from '@material-ui/core/Container';

interface Props {
  maxWidth?: any;
  className?: any;
}

const ContainerWrapper: React.FC<Props> = ({ children, maxWidth = 'lg', className }) => {
  return (
    <Container maxWidth={maxWidth} className={className}>
      {children as any}
    </Container>
  );
};

export default ContainerWrapper;
